@if (location() === "bottom") {
  <!-- Bottom reprise — the dark stage returns for the closing conversion block.
       data-scene="stage" re-binds the role tokens; the [grooveSpotlight] is the
       inset, radial-glow stage card (the single site-wide bottom-CTA treatment,
       inherited by every inner page and home alike). The wrapper paints nothing
       itself — the spotlight is the visible card. -->
  <div data-scene="stage" class="page-cta-reprise">
    <section grooveSpotlight class="page-cta-spotlight">
      <h2 class="page-cta-heading">{{ resolvedHeading() }}</h2>
      <p class="page-cta-body">{{ resolvedBody() }}</p>
      <div class="page-cta-actions">
        <a grooveAction [href]="phoneHref">
          {{ callLabel }}
        </a>
        <a grooveAction variant="ghost" [href]="emailHref">
          or send an email
        </a>
      </div>
    </section>
  </div>
} @else {
  <div class="page-cta page-cta-aside" grooveSurface>
    <h2 class="page-cta-heading">{{ resolvedHeading() }}</h2>
    <p class="page-cta-body">{{ resolvedBody() }}</p>
    <div class="page-cta-actions">
      <a grooveAction [href]="phoneHref">
        {{ callLabel }}
      </a>
      <a grooveAction variant="outline" [href]="emailHref">
        or send an email
      </a>
    </div>
  </div>
}
